module.exports = __webpack_public_path__ + "img/ArmadilloChecklist_4 2.50c4ad23.gif";